@if (vm.content) {
<div class="row">
   <div class="col-xs-12">
      <div class="accordion application-form">
         <div class="opener">
            <span class="num last"
               >3
               <i class="fa fa-check" aria-hidden="true"></i>
            </span>
            <h1>{{ vm.content.title }} - {{ vm.content.step3Title }}</h1>
            <p [innerHtml]="vm.content.step3Body"></p>
         </div>
         <div class="slide">
            <form #form="ngForm" (submit)="submitForm(form)" novalidate>
               <fieldset>
                  <legend class="sr-only">{{ vm.content.step3SubTitle }}</legend>
                  <div class="section">
                     <div class="row section__heading">
                        <div class="col-sm-6">
                           <h2>
                              {{ !tooManyAttemptsTrigger ? vm.content.step3SubTitle : vm.content.step3TooManyAttemptsErrorTitle }}
                           </h2>
                        </div>
                     </div>

                     @if (!tooManyAttemptsTrigger) {
                     <!-- Date of Birth Question -->
                     @if (questions && showQuestion('dateOfBirth')) {
                     <div class="row">
                        <div class="col-md-6">
                           <div class="form-group form-group--triple" [class.has-error]="dateOfBirth.invalid && dateOfBirth.touched">
                              <label class="control-label">{{ vm.content.step3DateOfBirthQuestionText }}</label>
                              <div class="has-feedback">
                                 <app-date-picker
                                    [order]="'dmy'"
                                    #dateOfBirth="ngModel"
                                    [timezone]="0"
                                    id="dateOfBirth"
                                    name="dateOfBirth"
                                    [(ngModel)]="vm.answers.dateOfBirth"
                                    [visible]="[true, true, true]"
                                    [yearOrder]="'desc'"
                                    [minDate]="vm.answers.dateOfBirthMinDate"
                                    [maxDate]="vm.answers.dateOfBirthMaxDate"
                                    [placeholder]="['Year', 'Month', 'Day']"
                                 ></app-date-picker>

                                 @if (dateOfBirth.invalid && dateOfBirth.touched) {
                                 <i class="fa fa-times-circle-o form-control-feedback" aria-hidden="true"></i>
                                 }
                              </div>
                              @if (dateOfBirth.invalid && dateOfBirth.touched) {
                              <div class="help-block">
                                 <div class="clearfix">Please enter a valid date</div>
                              </div>
                              }
                           </div>
                        </div>
                     </div>
                     }

                     <!-- Tenancy Start Date Question -->
                     @if (questions && showQuestion('tenancyStart')) {
                     <div class="row">
                        <div class="col-md-6">
                           <div class="form-group form-group--triple" [class.has-error]="tenancyStartDate.invalid && tenancyStartDate.touched">
                              <label class="control-label">{{ vm.content.step3TenancyStartDateQuestionText }}</label>
                              <div class="has-feedback">
                                 <app-date-picker
                                    [order]="'dmy'"
                                    #tenancyStartDate="ngModel"
                                    id="tenancyStartDate"
                                    name="tenancyStartDate"
                                    [(ngModel)]="vm.answers.tenancyStartDate"
                                    [visible]="[false, true, true]"
                                    [minDate]="vm.answers.tenancyStartDateMinDate"
                                    [maxDate]="vm.answers.tenancyStartDateMaxDate"
                                    [placeholder]="['Year', 'Month', 'Day']"
                                    [reverseYear]="true"
                                 ></app-date-picker>

                                 @if (tenancyStartDate.invalid && tenancyStartDate.touched) {
                                 <i class="fa fa-times-circle-o form-control-feedback" aria-hidden="true"></i>
                                 }
                              </div>
                              @if (tenancyStartDate.invalid && tenancyStartDate.touched) {
                              <span class="help-block">Please ensure you select both month and year</span>
                              }
                           </div>
                           <p>
                              <a (click)="showStartDateModal()" class="link-info" style="margin-top: 0px; cursor: pointer">
                                 <i class="fa fa-info-circle" aria-hidden="true"></i>
                                 <strong>Where do I find this information?</strong>
                              </a>
                           </p>
                        </div>
                     </div>
                     }

                     <!-- National Insurance Number Question -->
                     @if (questions && showQuestion('nationalInsuranceNumber')) {
                     <div class="row">
                        <div class="col-md-6">
                           <div
                              class="form-group"
                              [class.has-error]="nationalInsuranceNumber.invalid && nationalInsuranceNumber.touched"
                              [class.has-success]="nationalInsuranceNumber.valid"
                           >
                              <label class="control-label">{{ vm.content.step3NationalInsuranceNumberQuestionText }}</label>
                              <p>{{ vm.content.step3NationalInsuranceNumberSupplementalText }}</p>
                              <div class="has-feedback">
                                 <input
                                    #nationalInsuranceNumber="ngModel"
                                    [(ngModel)]="vm.answers.nationalInsuranceNumber"
                                    (input)="formatNationalInsurance($event)"
                                    pattern="^[A-Za-z]{2}[0-9]{6}[A-Za-z]{1}"
                                    type="text"
                                    class="form-control"
                                    id="nationalInsuranceNumber"
                                    name="nationalInsuranceNumber"
                                    maxlength="9"
                                    placeholder="AB123456C"
                                 />
                                 @if (nationalInsuranceNumber.invalid && nationalInsuranceNumber.touched) {
                                 <i class="fa fa-times-circle-o form-control-feedback" aria-hidden="true"></i>
                                 } @if (nationalInsuranceNumber.valid) {
                                 <i class="fa fa-check-circle-o form-control-feedback" aria-hidden="true"></i>
                                 }
                              </div>
                           </div>
                        </div>
                     </div>
                     }

                     <!-- Rent Charge Question -->
                     @if (questions && showQuestion('rentCharge')) {
                     <div class="row">
                        <div class="col-md-6">
                           <div
                              class="form-group"
                              [class.has-error]="
                                 (rentFrequency.value == 'null' && rentCharge.value != '') ||
                                 (rentFrequency.value != 'null' && rentCharge.value == '') ||
                                 rentCharge.invalid ||
                                 (rentCharge.value != undefined && rentCharge.value.length > 0 && +rentCharge.value <= 0)
                              "
                           >
                              <label class="control-label">{{ vm.content.step3RentChargeQuestionText }}</label>
                              <div class="has-feedback">
                                 <div class="row">
                                    <div class="col-md-5">
                                       <input
                                          #rentCharge="ngModel"
                                          [(ngModel)]="vm.answers.rentCharge"
                                          pattern="^\d+(\.\d{1,2})?"
                                          type="text"
                                          class="form-control form-control--with-bottom-margin"
                                          id="rentCharge"
                                          name="rentCharge"
                                          maxlength="8"
                                          placeholder="0.00"
                                       />
                                    </div>
                                    <div class="col-md-7">
                                       <select
                                          [(ngModel)]="vm.answers.rentFrequency"
                                          #rentFrequency="ngModel"
                                          id="rentFrequency"
                                          name="rentFrequency"
                                          class="form-control"
                                       >
                                          <option value="null" disabled>Select a frequency</option>
                                          <option value="Weekly">Weekly</option>
                                          <option value="Monthly">Monthly</option>
                                          <option value="Fortnightly">Fortnightly</option>
                                          <option value="Annually">Annually</option>
                                       </select>
                                    </div>
                                 </div>
                                 @if ((rentFrequency.value == 'null' && rentCharge.value != '') || (rentFrequency.value != 'null' && rentCharge.value
                                 == '') || rentCharge.invalid || (rentCharge.value != undefined && rentCharge.value.length > 0 && +rentCharge.value <=
                                 0)) {
                                 <i class="fa fa-times-circle-o form-control-feedback" aria-hidden="true"></i>
                                 }
                              </div>
                              @if ((rentFrequency.value == 'null' && rentCharge.value != '') || (rentFrequency.value != 'null' && rentCharge.value ==
                              '')) {
                              <span class="help-block">{{ vm.content.step3RentChargeEmptyMessage }}</span>
                              }
                           </div>
                           <p>
                              <a (click)="showRentChargeModal()" class="link-info" style="margin-top: 0px; cursor: pointer">
                                 <i class="fa fa-info-circle" aria-hidden="true"></i>
                                 <strong>Where do I find this information?</strong>
                              </a>
                           </p>
                        </div>
                     </div>
                     } }

                     <app-identification-error-summary></app-identification-error-summary>
                  </div>
                  @if (!(tooManyAttemptsTrigger || insufficientQuestions)) {
                  <div class="section">
                     <div class="btn-set clearfix">
                        <button
                           [disabled]="questions == null || disableSubmit == true || (form.invalid && form.touched)"
                           id="idvStep3ContinueButton"
                           class="btn btn-primary btn-send"
                        >
                           Continue
                        </button>
                        <button type="button" (click)="goBack()" id="idvStep3BackButton" class="btn btn-default">Back</button>
                     </div>
                  </div>
                  }
               </fieldset>
            </form>
         </div>
      </div>
   </div>

   <!-- Information Message Modal -->
   <app-modal
      modalId="informationMessageModal"
      [title]="vm.content.step3InformationMessageTitle"
      [config]="{ backdrop: 'static', keyboard: false }"
      size="lg"
      #informationModal
   >
      <div modal-body>
         <div [innerHTML]="vm.content.step3InformationMessageBody"></div>
      </div>
      <div modal-footer>
         <button type="button" class="btn btn-primary" (click)="modalService.close('informationMessageModal')">
            {{ vm.content.step3InformationMessageButton }}
         </button>
      </div>
   </app-modal>

   <!-- Start Date Question Modal -->
   <app-modal
      modalId="startDateQuestionModal"
      [title]="vm.content.step3TenancyStartDateModalTitle"
      [config]="{ backdrop: true, keyboard: true }"
      #startDateModal
   >
      <div modal-body>
         <div [innerHTML]="vm.content.step3TenancyStartDateModalBody"></div>
      </div>
      <div modal-footer>
         <button type="button" class="btn btn-primary" (click)="modalService.close('startDateQuestionModal')">Close</button>
      </div>
   </app-modal>

   <!-- Rent Charge Question Modal -->
   <app-modal
      modalId="rentChargeQuestionModal"
      [title]="vm.content.step3RentChargeModalTitle"
      [config]="{ backdrop: true, keyboard: true }"
      #rentChargeModal
   >
      <div modal-body>
         <div [innerHTML]="vm.content.step3RentChargeModalBody"></div>
      </div>
      <div modal-footer>
         <button type="button" class="btn btn-primary" (click)="modalService.close('rentChargeQuestionModal')">Close</button>
      </div>
   </app-modal>
</div>
}
